<div class="modal-overlay" (click)="fecharModal()">
  <div class="box-nova-tarefa" (click)="$event.stopPropagation()">
    <div class="row">
      <div class="col-md-6">
        <h5 class="fw-bold">
          <i class="fa fa-hand-holding-usd"></i> Confirmar Recebimento
        </h5>
      </div>
      <div class="col-md-6 text-end">
        <button type="button" class="btn-close" (click)="fecharModal()" aria-label="Close"></button>
      </div>
    </div>
    <hr>

    <div class="row g-3">
      <div class="col-md-12" *ngIf="recebimento.conta">
        <p><strong>Conta:</strong> {{ recebimento.conta.descricao }}</p>
      </div>

      <div class="col-md-6">
        <label for="valorRecebimento" class="form-label">Valor</label>
        <input type="text" class="form-control" name="valorRecebimento" id="valorRecebimento" [(ngModel)]="recebimento.valor"
               mask="separator.2" prefix="R$ " thousandSeparator="." decimalMarker="," [dropSpecialCharacters]="true">
      </div>

      <div class="col-md-6">
        <label for="dataRecebimento" class="form-label">Data de Recebimento</label>
        <input type="date" class="form-control" name="dataRecebimento" id="dataRecebimento" [(ngModel)]="recebimento.dataPagamento">
      </div>

      <div class="col-md-12 d-flex justify-content-end gap-2 mt-4">
        <button type="button" class="btn btn-light" (click)="fecharModal()">Cancelar</button>
        <button type="button" class="btn btn-success px-4 d-flex align-items-center gap-2" (click)="confirmarRecebimento()">
          Confirmar Recebimento
        </button>
      </div>
    </div>
  </div>
</div>
